// extracted by mini-css-extract-plugin
module.exports = {"data_container":"style_data_container__1bFwa","image_container":"style_image_container__2xWwY","video_container":"style_video_container__1-gUz","youtube":"style_youtube__2N0Bv"};